import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/", { replace: true });
      return;
    }
    const session_id = match[1];
    // strip hash from url
    window.history.replaceState(null, "", window.location.pathname);

    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id });
        setUser(data);
        navigate("/grove", { replace: true, state: { user: data } });
      } catch (e) {
        navigate("/", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div data-testid="auth-callback" className="min-h-screen flex items-center justify-center">
      <p className="font-serif-display text-2xl text-[#4E5A3D]">Planting your session…</p>
    </div>
  );
}
